import { MyAccountTheme, TradeInBannerClasses } from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

const tradeInBannerStyles = makeStyles<
  MyAccountTheme,
  object,
  TradeInBannerClasses
>(({ palette }) => ({
  container: {
    padding: '20px 40px',
    textAlign: 'center',
    backgroundColor: palette.warning.light,
    color: palette.common.black,
  },
  link: {
    color: palette.common.black,
    textDecorationColor: palette.common.black,
  },
}))

export default tradeInBannerStyles
